import React, { useState } from "react";
import { Toaster } from "react-hot-toast";
import MainNavigation from "components/navigation/MainNavigation";
import styled from "styled-components";
import { Outlet } from "react-router-dom";
import { SCREEN_WIDTH_BREAKPOINT } from "constant/common_constants";
import { DivMain } from "./style/layout_common.style";
import FooterBordura from "components/common/view_util/footer/FooterBordura";

export default function MainView() {
  const [menuOpen, setMenuOpen] = useState(false); // kontrola mobilnog menija

  return (
    <>
      <DivMain>
        <DivNavigation>
          <MainNavigation showMenu={menuOpen} setShowMenu={setMenuOpen} />
        </DivNavigation>

        <Toaster />

        {/* Sadržaj koji se pomera kada je meni otvoren */}
        <Div pushed={menuOpen}>
          <Outlet />
        </Div>

        <DivFooter>
          <FooterBordura />
        </DivFooter>
      </DivMain>
    </>
  );
}

const Div = styled.div<{ pushed?: boolean }>`
  display: flex;
  flex-direction: column;

  margin-left: 1rem;
  margin-top: 3.5rem;
  height: calc(100% - 60px - 28px);
  width: calc(100% - 2rem);
  color: ${(props) => props.theme.color.main};

  @media (min-width: ${SCREEN_WIDTH_BREAKPOINT}) {
    margin-left: calc(150px + 0.5% + ${(props) => props.theme.spacing.xl4});
    width: calc(
      100% - 150px - 0.5% - 2 * ${(props) => props.theme.spacing.xl4}
    );
  }
`;

const DivNavigation = styled.div`
  position: fixed;
  right: 0;
  margin-top: 0;
  width: 100%;
  overflow: auto;
  background-color: white;
  padding-bottom: 0.5rem;

  @media (min-width: ${SCREEN_WIDTH_BREAKPOINT}) {
    flex-direction: column;
    right: auto;
    margin-left: 0.5%;
    margin-top: ${(props) => props.theme.spacing.l};
    width: 150px;
    padding-bottom: 0;
  }
`;

const DivFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  height: 28px;
  width: 100%;
  background: white;
`;
